<div class="form-group row">
  <label for="description" class="col-sm-5 col-form-label">
    {{claimformService.lbl.description}}
  </label>
  <div class="col-sm-7">
    <textarea class="input-styles" rows="5" cols="30" id="description" [(ngModel)]="claimService.claimRoot.claim.description"
    name="description" maxlength="1500" pInputTextarea #description="ngModel"></textarea>
  </div>
</div>
